import { render, staticRenderFns } from "./EmployeeCards_Import.vue?vue&type=template&id=580b9934&scoped=true"
import script from "./EmployeeCards_Import.vue?vue&type=script&lang=js"
export * from "./EmployeeCards_Import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b9934",
  null
  
)

export default component.exports